"use strict";
var SpinnerType;
(function (SpinnerType) {
    SpinnerType[SpinnerType["normal"] = 0] = "normal";
    SpinnerType[SpinnerType["large"] = 1] = "large";
})(SpinnerType = exports.SpinnerType || (exports.SpinnerType = {}));

//# sourceMappingURL=Spinner.Props.js.map



//////////////////
// WEBPACK FOOTER
// ../components/Spinner/Spinner.Props.js
// module id = 150
// module chunks = 0